import React from 'react';
import Basepage, { BasePageState } from '../Basepage';
import './index.scss';

interface WiderrufsformularPageState extends BasePageState {
  name: string;
  email: string;
  street: string;
  zip: string;
  city: string;
  orderNumber: string;
  orderDate: string;
  receivedDate: string;
  items: string;
  submitState: 'idle' | 'submitting' | 'success' | 'error';
  errorMessage: string;
}

export default class WiderrufsformularPage extends Basepage<
  WiderrufsformularPageState,
  {}
> {
  initState(base: BasePageState): WiderrufsformularPageState {
    return {
      ...base,
      name: '',
      email: '',
      street: '',
      zip: '',
      city: '',
      orderNumber: '',
      orderDate: '',
      receivedDate: '',
      items: '',
      submitState: 'idle',
      errorMessage: '',
    };
  }

  getApiReqestUrl(): string {
    return this.state.apiBase + this.state.apiData.apiRequestUri;
  }

  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(_prevProp: any, _prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }
  pageHeaderGetter(): string | null {
    return '';
  }
  pageTitleGetter(): string {
    return 'Widerrufsformular';
  }
  getBreadCrumb(): JSX.Element {
    return <span></span>;
  }
  getType(): string {
    return 'WiderrufsformularPage';
  }

  private handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    this.setState({ [name]: value } as any);
  };

  private handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    this.setState({ submitState: 'submitting', errorMessage: '' });

    const payload = {
      name: this.state.name,
      email: this.state.email,
      street: this.state.street,
      zip: this.state.zip,
      city: this.state.city,
      orderNumber: this.state.orderNumber,
      orderDate: this.state.orderDate,
      receivedDate: this.state.receivedDate,
      items: this.state.items,
    };

    fetch(
      this.state.apiBase + '/index.php?frame=api&main_page=widerrufsformular',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      },
    )
      .then((res) => res.json())
      .then((data) => {
        if (data && data.body && data.body.widerrufsSuccess) {
          this.setState({ submitState: 'success' });
        } else {
          this.setState({
            submitState: 'error',
            errorMessage:
              (data && data.body && data.body.widerrufsError) ||
              'Es ist ein Fehler aufgetreten.',
          });
        }
      })
      .catch(() => {
        this.setState({
          submitState: 'error',
          errorMessage: 'Verbindungsfehler.',
        });
      });
  };

  renderChild(): JSX.Element {
    const s = this.state;

    if (s.submitState === 'success') {
      return (
        <div id="widerrufsformularPage">
          <div className="widerruf-success">
            <h1>Widerruf erhalten</h1>
            <p>
              Wir haben Ihren Widerruf erhalten und Ihnen eine
              Bestätigungs-E-Mail an <strong>{s.email}</strong> gesendet.
            </p>
            <p>
              Bitte senden Sie die Ware zurück. Wir erstatten den Kaufpreis
              innerhalb von 14 Tagen nach Eingang der Rücksendung.
            </p>
          </div>
        </div>
      );
    }

    return (
      <div id="widerrufsformularPage">
        <h1>Widerrufsformular</h1>
        <p className="widerruf-intro">
          Wenn Sie den Vertrag widerrufen wollen, füllen Sie bitte dieses
          Formular aus und senden es ab. Sie erhalten anschließend eine
          Bestätigung per E-Mail.
        </p>
        <form className="widerruf-form" onSubmit={this.handleSubmit} noValidate>
          <fieldset>
            <legend>Ihre Daten</legend>
            <div className="form-row">
              <label htmlFor="wf-name">
                Vor- und Nachname <span className="required">*</span>
              </label>
              <input
                id="wf-name"
                name="name"
                type="text"
                value={s.name}
                onChange={this.handleChange}
                required
                autoComplete="name"
              />
            </div>
            <div className="form-row">
              <label htmlFor="wf-email">
                E-Mail-Adresse <span className="required">*</span>
              </label>
              <input
                id="wf-email"
                name="email"
                type="email"
                value={s.email}
                onChange={this.handleChange}
                required
                autoComplete="email"
              />
            </div>
            <div className="form-row">
              <label htmlFor="wf-street">Straße und Hausnummer</label>
              <input
                id="wf-street"
                name="street"
                type="text"
                value={s.street}
                onChange={this.handleChange}
                autoComplete="street-address"
              />
            </div>
            <div className="form-row form-row--split">
              <div>
                <label htmlFor="wf-zip">PLZ</label>
                <input
                  id="wf-zip"
                  name="zip"
                  type="text"
                  value={s.zip}
                  onChange={this.handleChange}
                  autoComplete="postal-code"
                  maxLength={10}
                />
              </div>
              <div>
                <label htmlFor="wf-city">Ort</label>
                <input
                  id="wf-city"
                  name="city"
                  type="text"
                  value={s.city}
                  onChange={this.handleChange}
                  autoComplete="address-level2"
                />
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend>Bestellinformationen</legend>
            <div className="form-row">
              <label htmlFor="wf-items">
                Bezeichnung der Ware <span className="required">*</span>
              </label>
              <textarea
                id="wf-items"
                name="items"
                value={s.items}
                onChange={this.handleChange}
                required
                rows={3}
                placeholder="z.B. Mustermann, Max: Beispielbuch, ISBN 978-3-000-00000-0"
              />
            </div>
            <div className="form-row">
              <label htmlFor="wf-orderNumber">Bestellnummer</label>
              <input
                id="wf-orderNumber"
                name="orderNumber"
                type="text"
                value={s.orderNumber}
                onChange={this.handleChange}
                placeholder="optional"
              />
            </div>
            <div className="form-row form-row--split">
              <div>
                <label htmlFor="wf-orderDate">Bestellt am</label>
                <input
                  id="wf-orderDate"
                  name="orderDate"
                  type="date"
                  value={s.orderDate}
                  onChange={this.handleChange}
                />
              </div>
              <div>
                <label htmlFor="wf-receivedDate">Erhalten am</label>
                <input
                  id="wf-receivedDate"
                  name="receivedDate"
                  type="date"
                  value={s.receivedDate}
                  onChange={this.handleChange}
                />
              </div>
            </div>
          </fieldset>

          {s.submitState === 'error' && (
            <p className="widerruf-error">{s.errorMessage}</p>
          )}
          <p className="widerruf-required-note">
            <span className="required">*</span> Pflichtfelder
          </p>
          <button
            type="submit"
            className="widerruf-submit"
            disabled={s.submitState === 'submitting'}
          >
            {s.submitState === 'submitting'
              ? 'Wird gesendet…'
              : 'Widerruf absenden'}
          </button>
        </form>
      </div>
    );
  }
}
